"use strict";

exports.__esModule = true;
var _AppContainer = require("./AppContainer");
Object.keys(_AppContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppContainer[key]) return;
  exports[key] = _AppContainer[key];
});